import { render, staticRenderFns } from "./PageControls.vue?vue&type=template&id=cd69eca4&scoped=true&"
import script from "./PageControls.vue?vue&type=script&lang=js&"
export * from "./PageControls.vue?vue&type=script&lang=js&"
import style0 from "./PageControls.vue?vue&type=style&index=0&id=cd69eca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd69eca4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VSpacer,VToolbarTitle,VTooltip})
